// API
import {
  GetAnimalsList_animalsExtended_animals,
  GetAnimalsListVariables,
} from "api/MyLivestock/Animal/types/GetAnimalsList";
import { GetAnimalsFromField_field_animals } from "api/MyLivestock/Fields/types/GetAnimalsFromField";
// Hooks
import { useAnimals, AnimalsList } from "../useAnimals";
import { useStateSpecies } from "../useStateSpecies";

export const useAnimalsSpeciesActive = (
  defaultAnimals?:
    | (GetAnimalsList_animalsExtended_animals | GetAnimalsFromField_field_animals | null)[]
    | undefined
    | null,
  variables?: Omit<GetAnimalsListVariables, "animalTypeIds">,
): AnimalsList => {
  const { active: speciesActive } = useStateSpecies();

  return useAnimals(defaultAnimals, {
    ...variables,
    animalTypeIds: speciesActive?.id ? [Number(speciesActive?.id)] : undefined,
  });
};
